/**
 * AB实验模块API服务
 */
import { datalabHttp } from '@dbl/services/common';
import { AxiosRequestConfig } from 'axios';
import { ICalculateAbResultParams } from './types';

/**
 * 获取筛选器选项
 */
export function getAbConfig(params: {
  game_code: string;
}) {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/ab_testing/get_ab_config',
    method: 'post',
    data: params,
    errorHandler: true,
  };
  return datalabHttp(options);
}

/**
 * 获取筛选值
 */
export function getAbFilterValues(params: {
  game_code: string;
  mapping_id: number;
}) {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/ab_testing/get_filter_values',
    method: 'post',
    data: params,
    errorHandler: true,
  };
  return datalabHttp(options);
}

/**
 * 计算AB实验结果
 */
export function calculateAbResult(params: ICalculateAbResultParams) {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/ab_testing/calculate',
    method: 'post',
    data: params,
    errorHandler: true,
  };
  return datalabHttp(options);
}

/**
 * 下载AB实验结果
 * @param params 下载参数
 * @returns 
 */
export function downloadAbResult(params: ICalculateAbResultParams) {
  const options: AxiosRequestConfig = {
    url: 'api/v1/datalab/ab_testing/download_excel',
    method: 'post',
    data: params,
    errorHandler: true,
  };
  return datalabHttp(options);
}

/**
 * 预览AB实验SQL
 * @param params 下载参数
 * @returns 
 */
export function previewAbSql(params: ICalculateAbResultParams) {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/ab_testing/preview_sql',
    method: 'post',
    data: params,
    errorHandler: true,
  };
  return datalabHttp(options);
}